module.exports = __webpack_public_path__ + "img/w26-b4.d02c94dd.jpg";